module.exports = __webpack_public_path__ + "img/20190706155121606.c6a0c3f1.png";